import { types } from 'mobx-state-tree';
import { NewsFeedBaseModel } from './base.model';

export const NewsFeedPostModel = types.compose(
  'NewsFeedPost',
  NewsFeedBaseModel,
  types.model({
    type: types.literal('news'),
    category: types.optional(
      types.enumeration([
        'info',
        'order',
        'results_meeting',
        'good_know',
        'release',
        'tech_works',
        'sys_notify',
        'sys_offer',
      ] as const),
      'info'
    ),
  })
);
